import { render } from "./SolutionsHeader.vue?vue&type=template&id=107e98af&lang=pug"
const script = {}

import "./SolutionsHeader.vue?vue&type=style&index=0&id=107e98af&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__